/**
 * Maps raw network / API failures to short Spanish copy for the UI.
 * @param {unknown} error
 * @param {string} [fallback]
 * @returns {string}
 */
export const toUserFacingError = (
  error,
  fallback = 'Algo salió mal. Inténtalo de nuevo en unos segundos.'
) => {
  const raw =
    typeof error === 'string'
      ? error
      : error?.message || error?.error_description || ''

  const text = String(raw || '').trim()
  if (!text) return fallback

  const normalized = text.toLowerCase()

  if (
    normalized.includes('failed to fetch') ||
    normalized.includes('networkerror') ||
    normalized.includes('network request failed') ||
    normalized.includes('load failed') ||
    normalized.includes('fetch failed')
  ) {
    return 'No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo en unos segundos.'
  }

  if (
    normalized.includes('502') ||
    normalized.includes('503') ||
    normalized.includes('bad gateway') ||
    normalized.includes('service unavailable')
  ) {
    return 'El servicio de cálculo no está disponible por ahora. Inténtalo de nuevo en unos minutos.'
  }

  if (normalized.includes('cannot_deactivate_self')) {
    return 'No puedes desactivar tu propia cuenta.'
  }

  if (
    normalized.includes('desactivada') ||
    normalized.includes('account_inactive')
  ) {
    return text
  }

  if (
    normalized.includes('sesión no disponible') ||
    normalized.includes('jwt') ||
    normalized.includes('sub claim') ||
    normalized.includes('user_not_found') ||
    normalized.includes('unauthorized') ||
    normalized.includes('401')
  ) {
    return 'Tu sesión expiró. Vuelve a iniciar sesión e inténtalo de nuevo.'
  }

  // Keep known product / API messages that are already user-oriented (Spanish).
  if (/[áéíóúñ¿¡]/i.test(text) || text.length > 40) {
    return text
  }

  // Strip terse English internals like "Failed to fetch pension config".
  if (/^[A-Za-z0-9 _\-().,/:]+$/.test(text) && !text.includes(' ')) {
    return fallback
  }

  if (
    normalized.startsWith('failed to') ||
    normalized.includes('internal server') ||
    normalized.includes('user not found or missing')
  ) {
    return fallback === 'Algo salió mal. Inténtalo de nuevo en unos segundos.'
      ? 'No pudimos completar esta acción. Inténtalo de nuevo en unos segundos.'
      : fallback
  }

  return text || fallback
}
